export default "__VITE_ASSET__DqiERPOa__"